import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
function FileUploader(_ref) {
  let {
    uploadFile,
    renderLook,
    multiple,
    dropZoneProps,
    imgSize,
    text,
    sx
  } = _ref;
  const theme = useTheme();
  const {
    acceptedFiles,
    getRootProps,
    getInputProps
  } = useDropzone(_objectSpread2({
    onDrop: async files => {
      console.log(files);
      await uploadFile(files);
    },
    multiple
  }, dropZoneProps));
  return /*#__PURE__*/React__default.createElement("div", getRootProps({
    className: 'dropzone'
  }), /*#__PURE__*/React__default.createElement("input", getInputProps()), renderLook || /*#__PURE__*/React__default.createElement(Box, {
    sx: _objectSpread2({
      color: theme.customColors.grey[500],
      fontSize: '12px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer'
    }, sx),
    textAlign: "center",
    border: "1px dashed ".concat(theme.customColors.grey[300]),
    borderRadius: "3px",
    height: "110px",
    className: "crm-file-uploader"
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "meta-crm-icon-ic_uploadImage font-size-".concat(imgSize),
    style: {
      color: '#cbcbcb'
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    className: "crm-file-uploader-text",
    sx: {
      marginTop: '5px'
    }
  }, text)));
}
FileUploader.propTypes = {
  uploadFile: PropTypes.func,
  renderLook: PropTypes.node,
  multiple: PropTypes.bool,
  dropZoneProps: PropTypes.shape({}),
  sx: PropTypes.shape({}),
  imgSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  text: PropTypes.string
};
FileUploader.defaultProps = {
  uploadFile: () => {},
  renderLook: null,
  multiple: false,
  dropZoneProps: {},
  sx: {},
  imgSize: 64,
  text: 'Click to upload or Drag & Drop'
};
export { FileUploader as default };